import { useState } from "react";
import { PageHeader } from "../ui";
import { useAuth } from "../AuthContext";
import { AgendaTab } from "./reunioes/AgendaTab";
import { MeetingsTab } from "./reunioes/MeetingsTab";
import { AtasTab } from "./reunioes/AtasTab";

const TABS = [
  { key: "pautas", label: "Pautas" },
  { key: "reunioes", label: "Reuniões agendadas" },
  { key: "atas", label: "Atas" },
];

const Tab = ({ active, onClick, children, testid }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`px-4 py-2.5 text-[11px] uppercase tracking-[0.22em] border-b-2 -mb-px ${
      active
        ? "border-[#002776] text-[#002776] font-semibold"
        : "border-transparent text-slate-500 hover:text-slate-800"
    }`}
  >
    {children}
  </button>
);

export default function Reunioes() {
  const { user } = useAuth();
  const [tab, setTab] = useState("pautas");
  const isAdmin = user?.role === "admin";
  const isAssociate = user?.role === "associado";

  return (
    <div data-testid="reunioes-page">
      <PageHeader
        title="Reuniões"
        subtitle="Agende reuniões, sugira e designe pautas, e consulte as atas das reuniões anteriores."
      />
      <div className="flex border-b border-slate-200 mb-6 flex-wrap">
        {TABS.map((t) => (
          <Tab key={t.key} active={tab === t.key} onClick={() => setTab(t.key)} testid={`tab-${t.key}`}>
            {t.label}
          </Tab>
        ))}
      </div>
      {tab === "pautas" && <AgendaTab isAdmin={isAdmin} isAssociate={isAssociate} />}
      {tab === "reunioes" && <MeetingsTab isAdmin={isAdmin} />}
      {tab === "atas" && <AtasTab isAdmin={isAdmin} />}
    </div>
  );
}
